var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-side",staticStyle:{"margin-top":"0px"}},[_c('div',{staticClass:"list"},[_c('a',{on:{"click":function($event){return _vm.alert('현재 메뉴는 구현중입니다.')}}},[_c('strong',[_vm._v("토큰파워볼")]),_c('span',[_vm._v(_vm._s(_vm._f("countDown")(_vm.remainTime)))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }